<c-page-header [title]="'my-work' | transloco" />

<ion-content [fullscreen]="true" [scrollEvents]="true" (ionScrollEnd)="workSandbox.scrollTrigger$.next()">
  <div class="page-content">
    <c-worked-hours-and-payments />
  </div>
</ion-content>
